<template>
  <v-container fluid class="Thanks-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
  <v-col md="10">
    <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
        <v-col md="12">
            <v-row justify="center">
                <v-dialog v-model="congratulations" max-width="40%">
                    <v-card>
                        <v-row align="center" justify="center">
                            <v-col cols="11">
                                <v-row class="smartbell-modalContainer">
                                    <v-col cols="12" md="6" class="smartbell-modalContainerLeft">
                                        <img src="../assets/HappyCow.png" alt="">
                                    </v-col>
                                    <v-col cols="12" md="6" class="smartbell-modalContainerRight">
                                    <h2 class="smartbell-modalh2">Muchas gracias por su preferencia!!!</h2>
                                    <span class="smartbell-modalSpan">Tu rancho se actualizará para contar con las funciones del {{plan}} que acabas de contratar</span>
                                    <p class="smartbell-modalP">Recuerda que tu facturación se hará cada  mes ó año</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-col>
    </v-row>
    <v-footer color="#F9FDFE" padless class="smartbell-footer">
        <v-row justify="center" no-gutters>
            <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
            </v-col>
        </v-row>
    </v-footer>
  </v-col>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue'
export default {
  name: 'Thanks',
    data () {
      return {
          congratulations: true
      }
  },
  components: {
    NavBar
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    },
  },
  methods: {
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/Thanks.css';
</style>
